/**
 * Footer Component
 * Handles contact form submission and footer functionality
 */
export function initFooter() {
  const contactForm = document.getElementById('contact-form');
  const phoneInput = document.getElementById('phone');
  
  if (contactForm) {
    contactForm.addEventListener('submit', handleFormSubmit);
  }
  
  if (phoneInput) {
    initPhoneMask(phoneInput);
  }
}

// Функция для маски телефона +1
function initPhoneMask(input) {
  input.addEventListener('input', function(e) {
    let value = e.target.value.replace(/\D/g, '');
    
    // Если номер начинается с 1, оставляем как есть
    // Если нет, добавляем 1 в начало
    if (value.length > 0 && value[0] !== '1') {
      value = '1' + value;
    }
    
    // Ограничиваем до 11 цифр (1 + 10 цифр)
    if (value.length > 11) {
      value = value.slice(0, 11);
    }
    
    // Форматируем номер
    let formattedValue = '';
    if (value.length > 0) {
      formattedValue = '+' + value[0];
      if (value.length > 1) {
        formattedValue += ' (' + value.slice(1, 4);
        if (value.length > 4) {
          formattedValue += ') ' + value.slice(4, 7);
          if (value.length > 7) {
            formattedValue += '-' + value.slice(7, 11);
          }
        }
      }
    }
    
    e.target.value = formattedValue;
  });
  
  // Устанавливаем начальное значение +1
  if (!input.value) {
    input.value = '+1 ';
  }
  
  // Предотвращаем удаление +1
  input.addEventListener('keydown', function(e) {
    const cursorPosition = e.target.selectionStart;
    if ((e.key === 'Backspace' || e.key === 'Delete') && cursorPosition <= 3) {
      e.preventDefault();
    }
  });
  
  // При фокусе устанавливаем курсор после +1
  input.addEventListener('focus', function(e) {
    if (e.target.value === '+1 ' || e.target.value === '+1') {
      setTimeout(() => {
        e.target.setSelectionRange(3, 3);
      }, 0);
    }
  });
}

function handleFormSubmit(e) {
  e.preventDefault();
  
  const form = e.target;
  const submitBtn = form.querySelector('.footer__form-submit');
  const formData = new FormData(form);
  
  // Показываем состояние загрузки
  const originalText = submitBtn.textContent;
  submitBtn.textContent = 'Sending...';
  submitBtn.disabled = true;
  
  // Проверяем, что action установлен правильно
  const actionUrl = form.getAttribute('action');
  
  if (!actionUrl) {
    console.error('Form action URL is missing');
    showMessage('Configuration error. Please try again later.', 'error');
    submitBtn.textContent = originalText;
    submitBtn.disabled = false;
    return;
  }
  
  // Отправляем AJAX запрос
  fetch(actionUrl, {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    if (data.success) {
      showMessage('Thank you! Your message has been sent successfully.', 'success');
      form.reset();
    } else {
      showMessage(data.data || 'An error occurred. Please try again.', 'error');
    }
  })
  .catch(error => {
    console.error('Form submission error:', error);
    showMessage('An error occurred. Please try again.', 'error');
  })
  .finally(() => {
    // Восстанавливаем кнопку
    submitBtn.textContent = originalText;
    submitBtn.disabled = false;
  });
}

function showMessage(message, type) {
  // Удаляем предыдущие сообщения
  const existingMessage = document.querySelector('.form-message');
  if (existingMessage) {
    existingMessage.remove();
  }
  
  // Создаем новое сообщение
  const messageEl = document.createElement('div');
  messageEl.className = `form-message form-message--${type}`;
  messageEl.textContent = message;
  
  // Добавляем стили
  messageEl.style.cssText = `
    padding: 15px;
    margin: 20px 0;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
    ${type === 'success' 
      ? 'background-color: #d4edda; color: #155724; border: 1px solid #c3e6cb;' 
      : 'background-color: #f8d7da; color: #721c24; border: 1px solid #f5c6cb;'
    }
  `;
  
  // Вставляем сообщение перед формой
  const form = document.getElementById('contact-form');
  form.parentNode.insertBefore(messageEl, form);
  
  // Автоматически убираем сообщение через 5 секунд
  setTimeout(() => {
    if (messageEl.parentNode) {
      messageEl.remove();
    }
  }, 5000);
}
